import React, { useState } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import "../components/css/Gallery.css";

import img1 from "../media/images/garary/Swimming.jpg";
import img2 from "../media/images/garary/FH_UG-751.jpg";
import img3 from "../media/images/garary/FH_UG-516.jpg";
import img4 from "../media/images/garary/g29.jpg";
import img5 from "../media/images/garary/FH_UG-689.jpg";
import img6 from "../media/images/garary/FH_UG-74.jpg";
import img7 from "../media/images/garary/g11.jpg";
import img8 from "../media/images/garary/071.jpg";
import img9 from "../media/images/garary/g13.jpg";
import img10 from "../media/images/garary/g9.jpg";
import img12 from "../media/images/garary/FH_UG-58.jpg";
import img13 from "../media/images/garary/g10.jpg";

const images = [
  { src: img1, category: "views" },
  { src: img2, category: "grounds" },
  { src: img3, category: "dining" },
  { src: img4, category: "views" },
  { src: img5, category: "grounds" },
  { src: img6, category: "grounds" },
  { src: img7, category: "rooms" },
  { src: img8, category: "rooms" },
  { src: img9, category: "rooms" },
  { src: img13, category: "dining" },
  { src: img10, category: "dining" },
  { src: img12, category: "views" },
];

const filters = ["all", "grounds", "rooms", "dining", "views"];

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState("all");
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages =
    activeFilter === "all"
      ? images
      : images.filter((img) => img.category === activeFilter);

  return (
    <section className="gallery-section py-5">
      <Container>

        {/* HEADER */}
        <div className="text-center mb-4" data-aos="zoom-in">
          <small className="subtitle">GALLERY</small>
          <h2>Experience Father's House</h2>
        </div>

        {/* FILTER BUTTONS */}
        <div className="text-center mb-4" data-aos="fade-up">
          {filters.map((filter, index) => (
            <Button
              key={index}
              className={`filter-btn ${
                activeFilter === filter ? "active" : ""
              }`}
              onClick={() => setActiveFilter(filter)}
            >
              {filter.toUpperCase()}
            </Button>
          ))}
        </div>

        {/* GRID */}
        <Row key={activeFilter}>
          {filteredImages.map((img, index) => (
            <Col md={4} key={index} className="mb-4 gallery-item" data-aos="zoom-in" data-aos-delay={index * 100}>
              <div
                className="gallery-card"
                onClick={() => setSelectedImage(img.src)}
              >
                <img src={img.src} alt="" />
                <div className="overlay3">
                <span>VIEW</span>
              </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* MODAL (LIGHTBOX) */}
        <Modal
          show={!!selectedImage}
          onHide={() => setSelectedImage(null)}
          centered
          size="lg"
        >
          <Modal.Body className="p-0">
            <img
              src={selectedImage}
              alt="preview"
              className="img-fluid w-100"
            />
          </Modal.Body>
        </Modal>

      </Container>
     <div className="text-center" data-aos="slide-right" >
      <a href="gallery" className="story-link">
            View Full Gallery →
          </a>
      </div>    
    </section>
  );
};

export default Gallery;